module.exports = __webpack_public_path__ + "static/img/2-2.3fdd980.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/4/2/eng/2-2.png
// module id = M8+9
// module chunks = 0